module.exports = "<ul class=\"vertical-nav\">\n  <li ng-repeat=\"item in $ctrl.items\"><span>{{item.label}}</span></li>\n</ul>\n<!-- .vertical-nav END -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpVerticalNavigation/adpVerticalNavigation.html
// module id = 597
// module chunks = 0